export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-600 via-primary-500 to-accent-500 p-8 md:p-12">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-background-50"></div>
            <div className="absolute -bottom-10 -left-10 w-48 h-48 rounded-full bg-background-50"></div>
          </div>
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-2">
                内容合作与投稿咨询
              </h2>
              <p className="text-sm md:text-base text-background-50/80 max-w-lg">
                如果您有优质视频内容想要入驻私密视频平台，或者有任何合作咨询需求，
                欢迎通过以下方式与我们取得联系。我们珍视每一位内容创作者和合作伙伴。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-3 flex-shrink-0">
              <a
                href="mailto:contact@example.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line text-lg"></i>
                发送邮件咨询
              </a>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-question-line text-lg"></i>
                查看常见问题
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}